"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKey = void 0;
const getKey = (key) => key || Math.random().toString();
exports.getKey = getKey;
//# sourceMappingURL=getKey.js.map